import { gql } from "@apollo/client";

export const ADD_EMAIL = gql`
    mutation AddEmail(
        $emailAddress: String!,
        $emailType: TipoEmail!
    ) {
        agregarEmail(input: {
            direccion: $emailAddress
            tipoEmail: $emailType
        }) {
            email {
                id
                direccion
                principal
                confirmado
                tipoEmail
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const UPDATE_EMAIL = gql`
    mutation UpdateEmail(
        $id: ID!,
        $emailAddress: String!,
        $emailType: TipoEmail!,
        $principal: Boolean
    ) {
        editarEmail(input: {
            id: $id
            direccion: $emailAddress
            tipoEmail: $emailType
            principal: $principal
        }) {
            email {
                id
                direccion
                tipoEmail
                principal
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const MAKE_EMAIL_PRIMARY = gql`
    mutation UpdateEmail(
        $id: ID!,
        $principal: Boolean!
    ) {
        editarEmail(input: {
            id: $id
            principal: $principal
        }) {
            email {
                id
                principal
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const CONFIRM_EMAIL = gql`
    mutation ConfirmEmail($id: ID!, $clientId: String!) {
        confirmarEmail(input: {
            id: $id
            clientId: $clientId
        }) {
            email {
                id
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export const DELETE_EMAIL = gql`
    mutation DeleteEmail($id: ID!) {
        eliminarEmail(id: $id) {
            email {
                id
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;
